import { Component, Inject } from '@angular/core';
import { TranslatorService } from '../../../../services/translator_service';
import { ResponsiveService } from '../../../../services/responsive.service';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-activity-panel',
  imports: [TranslatePipe, RTLDivDirectiveDirective,CommonModule],
  templateUrl: './activity-panel.html',
  styleUrl: './activity-panel.scss',
})
export class ActivityPanel {
  isMobile: Boolean;
	currentLang;
	translationsObj;

  constructor(private responsiveService: ResponsiveService,private translator: TranslatorService, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
		this.translator.currentLangEmitter$
		.subscribe(async value=>{						
			this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			this.currentLang = value;	
		})
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
  }

  onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}
}
